import React, { ReactNode, createContext, useEffect, useState } from 'react'

// Função auxiliar para carregar o arquivo JSON
// const loadInitialRoleFromConfig = async (): Promise<Role> => {
//   try {
//     const response = await fetch('/src/assets/config.conf');
//     const data = await response.json();
//     return data;
//   } catch (error) {
//     console.error('Error loading initial role from config file:', error);
//     // Retorne a role padrão caso ocorra algum erro ao carregar o arquivo
//     return {
//       background_color: '',
//       presentation_image: '',
//       presentation_video: '',
//       group_active: true,
//       roulette_active: true,
//       data_roulette: [
//         {
//           option: "SEM PREMIO",
//           style: {},
//           quantity: 1
//         }
//       ],
//       styles: {
//         buttons_image_active: false,
//         buttons_color_background: '',
//         buttons_color_text: ''
//       },
//       subscription_group: [],
//       subscription: [],
//       subscription_config: {
//         label_next: ''
//       }
//     };
//   }
// };

type OptionsType = {
  optionValue: string;
};

export type RouletteType = {
  option: string,
  style: any,
  quantity: number
};

// Defina a interface para a Role
export interface Role {
  logo: string;
  background_color: string;
  background_image: string;
  presentation_image: string;
  presentation_video: string;
  group_active: boolean;
  roulette_active: boolean;
  data_roulette: RouletteType[];
  data_roulette2: RouletteType[];
  styles: {
    buttons_image_active: boolean;
    buttons_color_background: string;
    buttons_color_text: string;
  },
  subscription_group: {
    group_name: string;
    group_image: string;
    fields: {
      name: string;
      description: string;
      placeholder: string;
      type: string;
      options?: OptionsType[];
      format: string[];
      fontSize: number;
      colorText: string
      charCount: number;
      enabled: boolean;
      visible: boolean;
      mandatory: boolean;
      observation?: string;
    }[];
  }[];
  subscription: {
    fieldName: string;
    type: string;
    options?: OptionsType[];
    format: string[];
    fontSize: number;
    charCount: number;
    enabled: boolean;
    visible: boolean;
  }[];
  subscription_modules: {
    modules: [
      {
        config: {
          order: number, 
          "button-image": string,
          "button-label": string,
          "background-image": string,
          title: string,
          "title-color": string,
          lgpd: boolean
        },
        subscriptions: [
          {
            name: string;
            description: string;
            placeholder: string;
            type: string;
            options?: OptionsType[];
            format: string[];
            fontSize: number;
            colorText: string;
            charCount: number;
            enabled: boolean;
            visible: boolean;
            mandatory: boolean;
            observation?: string;
          }
        ]
      }
    ]    
  };
  subscription_config: {
    label_next: string;
  },
  presentation_final: {
    presentation_image_success: string;
    presentation_image_fail: string;
  },
  lgpd: string
}

// Crie o contexto com um valor inicial vazio
export interface RolesContextValue {
  roles: Role | undefined;
  updateRoles: (newRole: Role) => void;
}

export const RolesContext = createContext<RolesContextValue | undefined>(undefined);

// Provedor de contexto que gerencia o valor da Role
interface RolesProviderProps {
  children: ReactNode;
}

// Função para verificar se os dados do arquivo são válidos
const isValidRole = (data: any): data is Role => {
  // Implemente a lógica de validação aqui, se necessário
  // Por exemplo, verifique se todos os campos necessários estão presentes e têm o tipo correto
  return true;
};

export const RolesProvider: React.FC<RolesProviderProps> = ({ children }) => {
  const [roles, setRoles] = useState<Role | undefined>(undefined);

  // Use uma função assíncrona para buscar o arquivo de configuração
  useEffect(() => {
    // Carregue os dados do arquivo config.json diretamente
    import('../assets/config.json')
      .then((data) => {
        // Verifique se os dados carregados do arquivo são válidos
        if (isValidRole(data)) {
          updateRoles(data);
        } else {
          console.error('Erro ao carregar arquivo de configuração: dados inválidos');
        }
      })
      .catch((error) => {
        console.error('Erro ao carregar arquivo de configuração:', error);
      });
  }, []);


  // Função para atualizar a Role
  const updateRoles = (newRole: Role) => {
    setRoles(newRole);
  };

  const value: RolesContextValue = {
    roles,
    updateRoles,
  };

  return (
    <RolesContext.Provider value={value}>
      {/* Passa a função updateRoles como parte do valor do contexto */}
      {children}
    </RolesContext.Provider>
  );
};
